"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _printIframe = _interopRequireDefault(require("./printIframe"));
var _delayPromise = _interopRequireDefault(require("./delayPromise"));
/**
 * Add content to an iframe and wait until all images are loaded before resolving the promise.
 * @param {HTMLIFrameElement} iframe - The iframe element to add content to.
 * @param {string} content - The HTML content to add to the iframe.
 * @param delay
 * @returns {Promise<void>}
 */

function addContentInIframe(iframe, content) {
  var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var progress = arguments.length > 3 ? arguments[3] : undefined;
  return new Promise(function (resolve) {
    var _iframe$contentWindow;
    var contentDocument = iframe.contentDocument || ((_iframe$contentWindow = iframe.contentWindow) === null || _iframe$contentWindow === void 0 ? void 0 : _iframe$contentWindow.document);
    //add component into print
    if (contentDocument) {
      contentDocument.open();
      contentDocument.write(content);
      contentDocument.close();
    }
    // remove date/time from top
    var styleEl = contentDocument.createElement("style");
    var style = "\n            @page {\n                /* Remove browser default header (title) and footer (url) */\n                margin: 0;\n            }\n            @media print {\n                body {\n                    /* Tell browsers to print background image/colors */\n                    -webkit-print-color-adjust: exact; /* Chrome/Safari/Edge/Opera */\n                    color-adjust: exact; /* Firefox */\n                }\n            }\n        ";
    styleEl.appendChild(contentDocument.createTextNode(style));
    contentDocument.head.appendChild(styleEl);
    // get all elements need to load
    var images = contentDocument.querySelectorAll("img");
    var links = document.querySelectorAll("link[rel='stylesheet']");
    var elementsWithBackgroundImages = contentDocument.querySelectorAll('[style*="background-image"]');
    var total = images.length + links.length + elementsWithBackgroundImages.length;
    var loaded = [];
    function updateProgress() {
      var percentage = loaded.length / total;
      progress && progress(percentage);
    }
    function markLoaded(_x, _x2) {
      return _markLoaded.apply(this, arguments);
    } // Preload background images from inline styles
    function _markLoaded() {
      _markLoaded = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(node, error) {
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!error) {
                _context.next = 4;
                break;
              }
              console.warn(error, node);
              _context.next = 9;
              break;
            case 4:
              if (!(node.tagName === 'IMG' && !node.complete)) {
                _context.next = 7;
                break;
              }
              _context.next = 7;
              return new Promise(function (resolve) {
                node.onload = function () {
                  return resolve();
                };
                node.onerror = function () {
                  return resolve();
                }; // resolve even on error to continue the process
              });
            case 7:
              _context.next = 9;
              return (0, _delayPromise["default"])(delay);
            case 9:
              loaded.push(node);
              updateProgress();
              // Resolve if all elements are loaded
              if (total === loaded.length) {
                resolve();
              }
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _markLoaded.apply(this, arguments);
    }
    elementsWithBackgroundImages.forEach(function (el) {
      var backgroundImage = el.style.backgroundImage;
      // Use a regular expression to extract the URL
      var match = backgroundImage.match(/url\(["']?(.*?)["']?\)/);
      var imageUrl = match ? match[1] : '';
      var img = new Image();
      img.onload = function () {
        return markLoaded(el);
      };
      img.onerror = function (error) {
        return markLoaded(el, error);
      };
      img.src = imageUrl;
    });
    // Copy all styles from parent and load
    links.forEach(function (node) {
      var link = contentDocument.createElement(node.tagName);
      link.setAttribute("rel", "stylesheet");
      link.setAttribute("type", "text/css");
      link.setAttribute("href", node.getAttribute("href"));
      link.onload = function () {
        return markLoaded(node);
      };
      link.onerror = function (error) {
        return markLoaded(node, error);
      };
      contentDocument.head.appendChild(link);
    });

    // Pre-load all images
    images.forEach(function (imgNode) {
      var src = imgNode.getAttribute("src");
      if (!src) {
        markLoaded(imgNode, 'encountered a <img> tag with an empty "src" attribute. It will not attempt to pre-load it.');
      } else {
        var img = new Image();
        img.onload = function () {
          return markLoaded(imgNode);
        };
        img.onerror = function (error) {
          return markLoaded(imgNode, error);
        };
        img.src = src;
        img.loading = "eager";
      }
    });
  });
}
function createIFrame() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "printWindow";
  return new Promise(function (resolve, reject) {
    var iframe = document.createElement("iframe");
    iframe.style.position = "absolute"; // hide from user view
    iframe.width = "".concat(document.documentElement.clientWidth, "px");
    iframe.height = "".concat(document.documentElement.clientHeight, "px");
    iframe.style.top = "-".concat(document.documentElement.clientHeight + 100, "px");
    iframe.style.left = "-".concat(document.documentElement.clientWidth + 100, "px");
    iframe.id = id;
    iframe.title = "Print Window";
    iframe.srcdoc = "<!DOCTYPE html>";
    iframe.onload = function () {
      iframe.onload = null; // Ensures that it is only called once.
      resolve(iframe);
    };
    iframe.onerror = function (e) {
      return reject(e);
    };
    //remove first if already exist on the body
    var printWindow = document.getElementById(id);
    if (printWindow) {
      document.body.removeChild(printWindow);
    }
    document.body.appendChild(iframe);
  });
}
function printNode(node, _ref) {
  var fileName = _ref.fileName,
    delay = _ref.delay,
    progress = _ref.progress;
  return Promise.resolve().then(function () {
    return createIFrame();
  }).then(function (iframe) {
    return addContentInIframe(iframe, node.outerHTML, delay, progress).then(function () {
      return iframe;
    });
  }).then(function (iframe) {
    return (0, _printIframe["default"])(iframe, fileName).then(function () {
      return iframe;
    });
  });
}
function printComponent(component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var node = _reactDom["default"].findDOMNode(component);
  return printNode(node, options);
}
var _default = printComponent;
exports["default"] = _default;